import React from 'react';
import { Helmet } from 'react-helmet';
import Layout from '../../components/digital-media/layout';
import { Container, makeStyles, Grid } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    paddingTop: '130px',
    [theme.breakpoints.up('md')]: {
      paddingTop: '96px',
    },
    borderBottom: '1px solid #e1e1e1',
  },
  slotholder: {
    backgroundImage: `url('/img/digital-media/t_storage.png')`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: '50% 50%',
    width: '100%',
    height: '120px',
    [theme.breakpoints.up('md')]: {
      height: '200px',
    },
  },
  caption: {
    textAlign: 'center',
    color: 'white',
    fontSize: '30px',
    [theme.breakpoints.up('md')]: {
      fontSize: '48px',
      paddingTop: '65px',
      padingLeft: '90px',
    },
    paddingTop: '50px',
    paddingLeft: '80px',
  },
  captionEng: {
    textAlign: 'center',
    color: 'white',
    fontSize: '15px',
    [theme.breakpoints.up('md')]: {
      fontSize: '20px',
      paddingLeft: '260px',
    },
    paddingLeft: '140px',
    fontWeight: '200',
  },
  section1: {
    backgroundImage: `url('/img/digital-media/1231.png')`,
    backgroundRepeat: 'repeat-x',
    backgroundAttachment: 'scroll',
    backgroundPosition: 'top center',
    textAlign: 'center',
    fontsize: '16px',
    color: '#727272',
    paddingTop: '50px',
    paddingBottom: '50px',
  },
  section2: {
    paddingTop: '70px',
    paddingBottom: '100px',
    textAlign: 'center',
    borderBottom: '1px solid #e1e1e1',
    marginLeft: '20px',
    marginRight: '20px',
  },
  hr: {
    lineHeight: '25px',
    borderColor: '#dddddd',
    borderTopWidth: '1px',
    borderTopStyle: 'solid',
    position: 'relative',
    margintTop: '15px',
    marginBottom: '30px',
  },
  contents: {
    color: '#666666',
    fontSize: '14px',
    margin: '11.9px 0px',
    lineHeight: '1.65em',
    textAlign: 'left',
  },
  icon: {
    paddingTop: '30px',
  },
}));

export default function ArchiveSystem() {
  const classes = useStyles();
  return (
    <Layout>
      <Helmet>
        <title>MALGN | 스토리지 시스템</title>
      </Helmet>
      <div className={classes.wrapper}>
        <div className={classes.slotholder}>
          <div className={classes.caption}>스토리지 시스템</div>
          <div className={classes.captionEng}>Storage System</div>
        </div>
        <div className={classes.section1}>
          <Container maxWidth="md">
            <p>
              미디어 파일의 용량이 커지고 네트워크 기반의 협업 시스템이 보편화
              되는 상황에서
            </p>
            <p>공유 스토리지는 가장 중요한 인프라의 중심이 되었습니다.</p>
            <p>
              스토리지의 용량 및 속도에 따라 파이버채널(Fiber Channel)기반
              스토리지 또는 이더넷(Ethernet) 기반의 스토리지를 사용하며,
            </p>
            <p>
              스토리지의 운영 안정성을 높이기 위해 주요 인프라는 이중화 구성을
              합니다.
            </p>
            <p>
              파이버채널 기반의 SAN 스토리지는 보통 Xsan, SNFS 등의 공유
              파일시스템을 사용하여 스토리지를 공유하며,
            </p>
            <p>
              이더넷 기반의 NAS 스토리지 또한 별도의 클러스트 파일 시스템을
              가지고 대용량 스토리지 서비스를 제공합니다.
            </p>
          </Container>
        </div>
      </div>
      <div className={classes.section2}>
        <Container maxWidth="md">
          <div>
            <h1 style={{ textAlign: 'left' }}>
              HA-AP(HIGH AVAILABILITY APPLIANCE)
            </h1>
            <div className={classes.hr} />
            <p className={classes.contents}>
              HA-AP는 스토리지 유닛 대 유닛으로 미러링을 가능케 하는
              어플라이언스로서, 스토리지와 함께 사용하여 대용량의 SAN 볼륨
              전체를 이중화(미러링) 할 수 있습니다. 스토리지 컨트롤러가 이중화가
              되어 있다 하더라도 RAID로 구성된 LUN 중 한 개에서 장애가 발생할
              경우(RAID 5가 깨지는 등) 전체 데이터를 잃어버리는 치명적인
              위험성이 존재합니다.
              <br />
              HA-AP를 이용하여 하드웨어적인 미러링을 구성하면, 컨트롤러 이중화
              및 LUN 이중화가 모두 이루어지므로 안정성이 극대화되고 무중단
              서비스가 가능해집니다. 또한 노후화된 스토리지에 대한 교체가 요구될
              때, 이중화 구성을 이용하여 교체 작업시에도 무중단 서비스가
              가능합니다.
            </p>
            <div className={classes.imgSpace}>
              <img src="/img/digital-media/storage_prostudio_product2.png" />
            </div>
            <Grid container spacing={10} style={{ textAlign: 'left' }}>
              <Grid item xs={12} sm={6}>
                <h3>특징</h3>
                <p className={classes.contents}>
                  -1U의 하드웨어 어플라이언스
                  <br />
                  -오픈 구조의 HA SAN 지원
                  <br />
                  -빠른 구동시간 (일반적으로 10초 이내 부팅 )
                  <br />
                  -호스트 드라이버 변경없음
                  <br />
                  -데이터 저장시 변경 혹은 추가되는 데이터 없음
                  <br />
                  -고객의 환경별 SAN 호스트 라이센스
                </p>
              </Grid>
              <Grid item xs={12} sm={6}>
                <h3>장점</h3>
                <p className={classes.contents}>
                  -스토리지 장애시 지속적인 데이터 액세스
                  <br />
                  -연속적인 업무가능
                  <br />
                  -SAN 스토리지의 온라인 유지보수 가능
                  <br />
                  -이기종 스토리지 간에 온라인 마이그레이션을 가능
                  <br />
                  -관리 ​​및 서비스가 쉬움
                  <br />
                  -타사대비 저렴한 HA 솔루션
                </p>
              </Grid>
              <Grid item xs={12}>
                <h3>유사제품/제품비교</h3>
                <div>
                  <img src="/img/digital-media/haap.png" />
                </div>
              </Grid>

              <Grid item xs={12} sm={6}>
                <div className={classes.imgSpace}>
                  <img src="/img/digital-media/storage1.png" />
                  <h3 style={{ fontSize: '16px' }}>
                    Case 1. 실시간 스토리지 미러링
                  </h3>
                  <p className={classes.contents}>
                    물리적으로 다른 두 대의 스토리지를 HA-AP를 사용하여 고가용
                    스토리지 시스템을 구축합니다. 실시간 미러링 스토리지로
                    무중단 운영 시스템을 구성 할 수 있습니다.
                  </p>
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={classes.imgSpace}>
                  <img src="/img/digital-media/storage2.png" />
                  <h3 style={{ fontSize: '16px' }}>
                    Case 2. 이기종 스토리지 미러링 or 데이터 마이그레이션
                  </h3>
                  <p className={classes.contents}>
                    기존에 사용하는 스토리지가 있다면 동일 기종 또는 이기종
                    스토리지와도 이중화 구성을 할 수 있습니다. 또한, 기존(구형)
                    스토리지를 새 스토리지로 대체시 데이터 마이그레이션 용으로도
                    활용 가능합니다. 초기 셋업시 다운타임이 필요하지만, 데이터
                    마이그레이션 진행중에 서비스가 가능합니다.
                  </p>
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <div className={classes.section2}>
        <Container maxWidth="md">
          <div>
            <h1 style={{ textAlign: 'left' }}>FUJITSU ETERNUS DX SERIES</h1>
            <div className={classes.hr} />
            <p className={classes.contents}>
              ETERNUS DX Series는 다양한 업무 요건, SAN과 NAS를 동시 지원하는
              최신 통합형 스토리지입니다. 업무 우선순위에 맞추어 간편하게 자원
              배분이 가능하며, 전용 관리 솔루션 ETERNUS SF 제품을 사용할 경우
              관리자의 스토리지 관리 업무량을 줄일 수 있습니다.
              <br /> 통합 그래픽 유저 인터페이스(GUI)와 커맨드 라인
              인터페이스(CLI) 시스템으로 SAN과 NAS 관리를 일원화하여 사용자 중심
              환경이 편리하게 구현되어 있습니다.
              <br />
              필요에 따라서 블록 스토리지를 구입하여 사용하다가 향후에
              유니파이드 시스템으로 업그레이드 할 수 있어 투자비용에 부담을
              느끼는 중소기업부터 대규모 IT 자원을 운용하는 대기업까지 다양한
              업무 환경에 사용 될 수 있습니다.
            </p>
            <Grid container>
              <Grid item>
                <h3 style={{ textAlign: 'left' }}>특징</h3>
                <p className={classes.contents}>
                  – 업그레이드 옵션을 통한 확장성
                  <br />
                  – 공간 재할당을 위한 씬프로비저닝
                  <br />
                  – 원격지 등가 카피
                  <br />
                  – 데이터 암호화
                  <br />
                  – 주요 동작부품 이중화 또는 다중화
                  <br />– 타사동급 제품 대비 월등한 캐쉬 및 FC 포트
                </p>

                <h3 style={{ textAlign: 'left' }}>고객사</h3>
                <p className={classes.contents}>KBS, KTV</p>
                <div className={classes.imgSpace}>
                  <img src="/img/digital-media/storage_table.png" />
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <div className={classes.section2}>
        <Container maxWidth="md">
          <div style={{ marginBottom: '100px' }}>
            <h1 style={{ textAlign: 'left' }}>PROMISE VTRAK A-CLASS</h1>
            <div className={classes.hr} />
            <p className={classes.contents}>
              VTrak A-Class 는 SAN 파일시스템 구성에 최적화된 스토리지로써
              메타데이터를 직접 관리하여 별도의 메타데이터 네트워크 구성이
              불필요 합니다. 간단한 설치 및 최소한의 관리만으로 Mac, Linux,
              Windows 클라이언트에 파이버채널 기반의 고속 데이터 엑세스를
              제공하며, I/O성능, 가용성 및 데이터 보안에 구애받지 않고 간단하게
              확장 가능합니다. VTrak A-Class 시리즈는 공유 디지털 미디어 제작,
              응용 프로그램 및 고가용성 기업 데이터 스토리지에 가장 적합합니다.
            </p>
            <Grid container>
              <Grid item>
                <h3 style={{ textAlign: 'left' }}>특징</h3>
                <p className={classes.contents}>
                  – 별도의 메타데이터 서버가 필요없는 완벽한 통합 공유
                  스토리지(메타데이터 관리 기능 자체 제공)
                  <br />
                  – 단기간에 고성능 워크플로우 시스템을 구축할 수 있음
                  <br />
                  – 서버와 통합된 아키텍처로 스토리지 인프라 설비 투자 비용 절감
                  <br />
                  – 손쉬운 성능 및 용량 확장 가능
                  <br />
                  – Mac, Linux, Windows 클라이언트 지원
                  <br />– 컨트롤러당 8Gbps 파이버채널 4포트 지원
                  <br />– I/O 성능과 전력 사용률에 대한 모니터링
                </p>
                <br />
                <br />
                <br />
                <div className={classes.imgSpace}>
                  <img src="/img/digital-media/promise1.png" />
                </div>

                <Grid container spacing={6}>
                  <Grid item xs={12} sm={4}>
                    <div className={classes.imgSpace}>
                      <img src="/img/digital-media/storage_pegasusrx.png" />
                    </div>
                    <p>Pegasus RAID Storage with Thunderbolt</p>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <div className={classes.imgSpace}>
                      <img src="/img/digital-media/storage_e630.png" />
                    </div>
                    <p>VTrak x30 Series for Mac OS X</p>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <div className={classes.imgSpace}>
                      <img src="/img/digital-media/storage_lightlink.png" />
                    </div>
                    <p>
                      SANLink – Fibre Channel adapter using Thunderbolt
                      Technology
                    </p>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <div className={classes.section2}>
        <Container maxWidth="md">
          <div style={{ marginBottom: '100px' }}>
            <h1 style={{ textAlign: 'left' }}>HARMONIC MEDIAGRID</h1>
            <div className={classes.hr} />
            <p className={classes.contents}>
              Harmonic MediaGrid 스토리지는 미디어 워크플로우에 특화된 Scale-out
              방식의 스토리지로서 Windows, Mac, Linux 각각의 파일시스템
              드라이버를 제공하며 최상의 확장성과 가용성을 제공합니다. 메인과
              백업으로 구성했을 경우 동적으로 Active-Active로 동작하여
              클라이언트별 로드밸런싱이 제공되어 무중단 서비스가 가능하도록
              설계되었습니다. 또한 MediaGrid는 단일 IP 네트워크에서 SAN과 동일한
              구조로 저비용 고성능의 공유 파일시스템을 무상으로 제공합니다.
            </p>
            <Grid container spacing={10}>
              <Grid item xs={12} sm={6}>
                <h3 style={{ textAlign: 'left' }}>특징</h3>
                <p className={classes.contents}>
                  – All Ethernet 기반 최소한의 시스템 관리로 운용 가능하며 SAN의
                  성능 구현
                  <br />
                  – 단순히 ContentStores만 추가하여 저비용으로 대역폭과 용량
                  확장
                  <br />
                  – 용량과 성능 확장시 다운타임 없이 스토리지 추가 가능
                  <br />
                  – 다수의 미디어 벤더와 정합 및 다양한 미디어 애플리케이션에
                  최적화
                  <br />
                  – 고가용클러스터를 생성하기 위해 MDC간 지속적인 커뮤니케이션과
                  싱크유지
                  <br />
                  – 분산 파일 시스템을 사용하여 복수의 노드에 분산된 데이터를
                  동시 접속
                  <br />
                  – 클라이언트가 낼 수 있는 최대의 대역폭 지원
                  <br />
                  – 스토리지와 파일시스템을 동일한 벤더에서 공급
                  <br />
                </p>
              </Grid>
              <Grid item xs={12} sm={6}>
                <img src="/img/digital-media/storage_mediagrid.png" />
                <br />
                Harmonic MediaGrid
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <div className={classes.section2}>
        <Container maxWidth="md">
          <div style={{ marginBottom: '100px' }}>
            <h1 style={{ textAlign: 'left' }}>
              SAN CLUSTER FILE SYSTEM_XSAN & SNFS
            </h1>
            <div className={classes.hr} />
            <p className={classes.contents}>
              디지털 방송환경에서 스토리지의 중요성은 점차 높아지고 있습니다.
              수백 테라바이트 이상의 용량과 고속의 전송 속도에 대응하려면
              일반적인 DAS나 NAS로는 원활한 서비스가 어렵습니다. 고속의 SAN
              기반의 스토리지 공유 파일시스템을 도입하는 고객의 상당수는 이런
              고민으로부터 자유로워졌으며, 편집자들 또한 빠르고 통합된 스토리지
              인프라를 통해 크리에이티브한 작업에 더 많은 시간을 할당할 수
              있습니다. Xsan 과 SNFS(StorNext File System)는 동일한 파일
              시스템을 사용하여 완벽하게 상호 호환되며 Mac OS X, Windows, Linux,
              UNIX 등의 다양한 환경을 통합 지원합니다.
            </p>
            <Grid container spacing={10}>
              <Grid item xs={12} sm={6}>
                <h3 style={{ textAlign: 'left' }}>특징</h3>
                <p className={classes.contents}>
                  – 다양한 운영체제 지원
                  <br />
                  – 64bit 클러스트 파일 시스템 확장
                  <br />
                  – Multi-Path I/O(MPIO) 지원
                  <br />
                  – Data Pool 구성으로 효율적인 I/O관리 최적화
                  <br />
                  – 원격 관리툴 지원 싱크유지
                  <br />
                  – 2PB 이상의 단일 볼륨 생성 가능 동시 접속
                  <br />
                  – Quota 관리
                  <br />
                  – Active Directory 및 Open Directory 연동 지원
                  <br />
                </p>
              </Grid>
              <Grid item xs={12} sm={6}>
                <img src="/img/digital-media/storage_stornextpro.png" />
                <br />
                Stornext Pro Solution
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>
    </Layout>
  );
}
